// extracted by mini-css-extract-plugin
module.exports = {"NoImageSrc":"AvatarImage_NoImageSrc__jFIZ6","avatar":"AvatarImage_avatar__lqtK_","square":"AvatarImage_square__wijF9"};